export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000' as const;

export const isEmptyGuid = (value: string | null | undefined): boolean => value === EMPTY_GUID;
